import { Pipe, PipeTransform } from "@angular/core";
import { ChanceNodeDto } from "@api";

@Pipe({ name: "filterScenarios" })
export class FilterScenariosPipe implements PipeTransform {
  public transform(scenario: ChanceNodeDto, searchTerm: string): boolean {
    if (!scenario) return false;
    if (!searchTerm) return true;

    return (
      scenario.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      scenario.description?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }
}
